import { ActionButton } from '@/components/common/ActionButton';
import type { CSSProperties } from 'react';
import { Actions, vars } from '@/theme';
import { emptyStates } from '@/constants';
import { tryAgain } from './regionLoadState.css';

/**
 * The ONE "line + quiet control" layout (Q-656): the line, then the control, centred, with no gap
 * between them (the control carries its own 8 px top margin, so the line sits ~21 px above it).
 * ViewContainer's failure rows and UnreachableState both spread this, so they cannot drift.
 */
export const quietFailureStack: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 0,
  padding: vars.spacing.xl,
};

/**
 * The quiet "Try again" text control (copied from 'Select All'). Exported on its
 * own so a later slice can sit it under an existing waiting look (Q-509 a).
 * `beside`: it sits in the same line as a sentence, same text size and baseline
 * as that sentence (the row failure line, Q-506 card 1524).
 */
export function RegionTryAgain({ onRetry, testId, beside = false, label = emptyStates.error.regionRetry, action = Actions.retry }: {
  onRetry: () => void;
  testId?: string;
  beside?: boolean;
  /** Another word on the same control (ProtectedRoute's Retry, ViewContainer's Return Home); the look is this one. */
  label?: string;
  /** The action descriptor behind the label; defaults to retry. */
  action?: typeof Actions.retry;
}) {
  return (
    <ActionButton
      action={action}
      mode="inline"
      label={label}
      onClick={onRetry}
      testIdOverride={testId}
      className={tryAgain}
      style={beside ? { fontSize: 'inherit', marginTop: 0, paddingLeft: 0, verticalAlign: 'baseline' } : { fontSize: '0.75rem' }}
    />
  );
}
